import format from 'date-fns/format';

export default (date: Date): string => format(date, 'dddd MMMM Do h:mm A');
